// extracted by mini-css-extract-plugin
export default {"tableButton-container":"Button1_tableButton-container__9NSWw","image":"Button1_image__rOB+m"};